import React, {useState} from 'react';
import {View} from 'react-native';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {Text, Pressable, Link} from '~/components/controls';
import ExpandLessIcon from '~/images/md-icons/expand_less/materialicons/24px.svg';
import ExpandMoreIcon from '~/images/md-icons/expand_more/materialicons/24px.svg';
import PropTypes from 'prop-types';

import {EditDialog} from '../../Grouping/EditDialog';
export {EditDialog};

const isEditDialog = (child) =>
  child?.type === EditDialog || child?.type?.isGroupingEditDialog === true;

export const Row = ({
  disabled = false,
  title,
  style,
  titleStyle,
  linkStyle,
  contentStyle,
  children,
  onEditClicked,
}) => {
  const contents = React.Children.map(children, (child) =>
    isEditDialog(child) ? null : child,
  );

  const dialog = React.Children.toArray(children).find(isEditDialog);

  const [edit, setEdit] = useState(false);

  return (
    <>
      <View
        style={[
          sy['p-4'],
          sy['flex-row'],
          sy['justify-between'],
          sy['gap-4'],
          {minHeight: 56, marginBottom: -1},
          style,
        ]}
      >
        {title && <Text style={titleStyle}>{title}</Text>}
        {!dialog && <View style={contentStyle}>{contents}</View>}
        {dialog && (
          <>
            <Link
              disabled={disabled}
              style={contentStyle}
              textStyle={linkStyle}
              onPress={async () => {
                if (onEditClicked) {
                  await onEditClicked();
                }

                setEdit(!edit);
              }}
            >
              {contents}
            </Link>
            {React.cloneElement(dialog, {
              visible: edit,
              onClose: () => {
                dialog.props.onClose?.();
                setEdit(false);
              },
            })}
          </>
        )}
      </View>
      <View style={[sy['px-4']]}>
        <Divider style={sy['bg-gray95']} />
      </View>
    </>
  );
};
Row.propTypes = {
  disabled: PropTypes.any,
  title: PropTypes.any,
  style: PropTypes.any,
  titleStyle: PropTypes.any,
  linkStyle: PropTypes.any,
  contentStyle: PropTypes.any,
  children: PropTypes.any,
  onEditClicked: PropTypes.any,
};

const Grouping = ({
  icon,
  header,
  headerRight,
  children,
  style,
  pressableStyle,
  onExpand,
  initial = {expand: false},
  options = {switchChevrons: false},
}) => {
  const [expand, setExpand] = useState(initial.expand);

  const hasChildren = React.Children.toArray(children).length > 0;
  let chevron = null;

  if (hasChildren) {
    if (options.switchChevrons) {
      chevron = expand ? <ExpandMoreIcon /> : <ExpandLessIcon />;
    } else {
      chevron = expand ? <ExpandLessIcon /> : <ExpandMoreIcon />;
    }
  }

  return (
    <View>
      <View style={[sy['bg-white'], sy['rounded-lg'], style]}>
        <Pressable
          style={[
            sy['flex-row'],
            sy['items-center'],
            sy['justify-between'],
            sy['p-4'],
            sy['gap-4'],
            pressableStyle,
          ]}
          disabled={!hasChildren}
          onPress={() => {
            const value = !expand;
            setExpand(value);
            if (onExpand) {
              onExpand(value);
            }
          }}
        >
          <View
            style={[
              sy['flex-row'],
              sy['flex-1'],
              sy['items-center'],
              sy['gap-4'],
              headerRight && {minWidth: 0},
            ]}
          >
            {icon && <View>{icon}</View>}
            <Text style={[sy.mediumPlus, sy.truncate]}>{header}</Text>
          </View>
          {headerRight && <View style={{flexShrink: 0}}>{headerRight}</View>}
          {chevron}
        </Pressable>
        {expand && <Divider style={sy['bg-gray88']} />}
        {expand && <>{children}</>}
      </View>
    </View>
  );
};
Grouping.propTypes = {
  icon: PropTypes.any,
  header: PropTypes.any,
  headerRight: PropTypes.node,
  children: PropTypes.any,
  style: PropTypes.any,
  pressableStyle: PropTypes.any,
  onExpand: PropTypes.any,
  initial: PropTypes.any,
  options: PropTypes.any,
};

export default Grouping;
